import { StencilCDNImage } from '@/components/Common/StencilImage'
import { BETA_INDSTOCKS_HOST, INDSTOCKS_HOST } from '@/root/constants/common'
import classNames from 'classnames'

const data = [
  {
    alt: 'INDmoney ISO 27001:2022 Certified',
    text_one: '27001:2022',
    iconUrl: 'https://indcdn.indmoney.com/cdn/images/fe/secured-icon.png',
    text_two: 'ISO Certified',
  },
  {
    iconUrl:
      'https://indcdn.indmoney.com/cdn/images/fe/iso-certification-icon.png',
    alt: 'INDmoney security audited by CERT-In empanelled auditors',
    text_one: 'Audited by',
    text_two: 'cert-in empanelled auditors',
  },
  {
    iconUrl: 'https://indcdn.indmoney.com/cdn/images/fe/audited-by-icon.png',
    alt: 'AES 256-BIT SSL Secured connection for INDmoney',
    text_one: 'AES 256-BIT',
    text_two: 'SSL Secured',
  },
]

export function StrapiV4PrivacyWidget({ host }: { host?: string }) {
  const isIndstocks = host === INDSTOCKS_HOST || host === BETA_INDSTOCKS_HOST
  return (
    <div className="text-brand-white flex flex-col items-center justify-between lg:flex-row">
      <section className="flex flex-col gap-y-5 lg:gap-y-8">
        <div>
          <p className="text-brand-green-ticker text-2xl font-semibold">
            {isIndstocks ? 'INDstocks' : 'INDmoney'} is 100% Safe and Secure!
          </p>
          <p className="mt-8 text-4xl font-semibold leading-10 lg:max-w-2xl lg:text-[3.375rem] lg:leading-[4.125rem]">
            Your security and privacy are our top priority!
          </p>
        </div>

        <ul className="lg:border-1 my-8 flex flex-col gap-4 rounded-xl lg:flex-row lg:border-white/25 lg:py-3">
          {data.map((el, index) => {
            return (
              <li
                key={el.alt}
                className={classNames('flex items-center gap-5 lg:px-4', {
                  'lg:border-l lg:border-white/25': !!index,
                })}
              >
                <div className="flex-shrink-0">
                  <StencilCDNImage
                    src={el.iconUrl}
                    width={44}
                    height={44}
                    alt={el.alt}
                  />
                </div>

                <div>
                  <p className="text-xs font-normal">{el.text_one}</p>
                  <p>{el.text_two}</p>
                </div>
              </li>
            )
          })}
        </ul>
      </section>

      <StencilCDNImage
        src={
          isIndstocks
            ? 'https://indcdn.indmoney.com/cdn/images/fe/indstocks_shield.png'
            : 'https://indcdn.indmoney.com/cdn/images/fe/shieldnew.png'
        }
        width={280}
        height={280}
        alt="INDmoney is 100% Safe and Secure - Security Shield icon"
      />
    </div>
  )
}
